
import { Component, Vue, Prop } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';

@Component
export default class DeliveryInfo extends Vue {
    @Prop({default: null})
    private customer: any;
}
